import { useStandardToast } from '@cksoftware/react-base';
import { PropsWithChildren } from 'react';
import { setAxiosOnError } from './src/util/axios';
import { setSignalROnError } from './src/features/liveAuction/hub/liveAuctionServerHub.ts';

export const ErrorContainer = ({ children }: PropsWithChildren<Record<never, never>>) => {
  const toast = useStandardToast();

  setAxiosOnError((error) => {
    const url = error?.request?.responseURL ?? 'Unknown';
    const statusCode = error?.response?.status ?? 'Unknown';
    const message = error?.message ?? 'Unknown';
    toast.errorToast('API Call Failed', `The API call to ${url} failed with code ${statusCode} and message ${message}`);
  });

  setSignalROnError((error) => {
    const message = error?.message ?? 'Unknown';
    toast.errorToast('SignalR Call Failed', `The SIGR call failed with ${message}`);
  });

  return <>{children}</>;
};
